import { defineMessages } from "react-intl"

export const reimbursementCategoryNameMessages = defineMessages({
  ADOPTION_AND_GC: {
    defaultMessage: "Adoption & gestational surrogacy expenses"
  },
  ADOPTION: {
    defaultMessage: "Adoption expenses"
  },
  DEFAULT: {
    defaultMessage: "Default"
  },
  GC: {
    defaultMessage: "Gestational surrogacy expenses"
  },
  MEDICATION: {
    defaultMessage: "Medication expenses"
  },
  OTHER: {
    defaultMessage: "Other expenses"
  },
  QME: {
    defaultMessage: "Qualified medical expenses"
  },
  M_LT: {
    defaultMessage: "Menopause & low-testosterone expenses"
  }
})
